<template>
  <div>
    <div class="header">
      <h1 class="page-title">首页</h1>
    </div>
    <!-- 头部卡片 -->
    <div class="cardtou">
      <div class="one">
        <img src="../../../assets/user/balance.png" alt />
        <div class="one-cont">
          <span class="one-yuan">账户余额（元）</span>
          <span class="one-money">{{money}}</span>
        </div>
      </div>
      <div class="one">
        <img src="../../../assets/user/hongbao.png" />
        <div class="one-cont">
          <span class="one-yuan">可用红包（元）</span>
          <span class="one-money">0.00</span>
        </div>
      </div>
      <div class="one">
        <img src="../../../assets/user/jifen.png" />
        <div class="one-cont">
          <span class="one-yuan">可用积分（元）</span>
          <span class="one-money">0</span>
        </div>
      </div>
      <div class="one">
        <img src="../../../assets/user/daijinquan.png" />
        <div class="one-cont">
          <span class="one-yuan">优惠券（张）</span>
          <span class="one-money">0</span>
        </div>
      </div>
    </div>
    <!-- 订单中心 -->
    <div class="dingdan">
      <div class="ding-tou">
        <img class="ding-pic" src="../../../assets/user/dingcont.png" />
        <span>订单中心</span>
      </div>
      <div class="ding-cont">
        <div class="ding-left">
          <router-link to="/order">
            <button>我的订单</button>
          </router-link>
          <button class="ding-btn">快速下单</button>
        </div>
        <div class="ding-right">
          <div class="two two-1" @click="goOrder(1)">
            <span>待付款</span>
            <span class="two-num">{{num1}}</span>
          </div>
          <div class="two two-2" @click="goOrder(3)">
            <span>待收货</span>
            <span class="two-num">{{num2}}</span>
          </div>
          <div class="two two-3" @click="goOrder(4)">
            <span>待评价</span>
            <span class="two-num">{{num3}}</span>
          </div>
          <div class="two two-4" @click="goOrder()">
            <span>全部订单</span>
            <span class="two-num">{{num4}}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 订单汇总 -->
    <div class="dingdan danhui">
      <div class="ding-tou">
        <img class="ding-pic" src="../../../assets/user/dingcont.png" alt />
        <span>订单汇总</span>
      </div>
      <div class="huizong" id="main"></div>
    </div>
  </div>
</template>

<script>
import echarts from 'echarts'
export default {
  data() {
    return {
      money: '',
      num1: '',
      num2: '',
      num3: '',
      num4: '',
      option: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        legend: {
          data: ['月订单金额', '月订单数']
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          splitLine: { show: false },
          data: []
        },
        yAxis: {
          type: 'value',
          scale: true,
          name: '金额(元)',
          max: 5000,
          min: 0,
          boundaryGap: [0.2, 0.2]
        },
        series: [
          {
            name: '月订单金额',
            type: 'bar',
            data: [],
            itemStyle: {
              normal: {
                color: 'rgb(14, 175, 99)' //柱状图颜色
              }
            }
          },
          {
            name: '月订单数',
            type: 'bar',
            data: [],
            itemStyle: {
              normal: {
                color: 'rgb(250, 173, 20)' //柱状图颜色
              }
            }
          }
        ]
      }
    }
  },
  methods: {
    goOrder(status = 0) {
      window.sessionStorage.setItem('status', status)
      this.$router.push('/order')
    },
    // 首页数据
    async getYue() {
      let param = new URLSearchParams()
      param.append('token', window.localStorage.getItem('token'))
      const { data: res } = await this.$http({
        method: 'post',
        url: 'api/mine/index',
        data: param
      })
      this.money = res.data.money
      //订单状态
      const { data: ress } = await this.$http({
        method: 'post',
        url: 'api/mine/orderinfo',
        data: param
      })
      let orderinfo = ress.data
      for (var i = 0; i < orderinfo.length; i++) {
        if (orderinfo[i].status == 1) {
          this.num1 = orderinfo[i].value
        } else if (orderinfo[i].status == 3) {
          this.num2 = orderinfo[i].value
        } else if (orderinfo[i].status == 4) {
          this.num3 = orderinfo[i].value
        } else if (orderinfo[i].status == 0) {
          this.num4 = orderinfo[i].value
        }
      }
    },
    //订单汇总
    async getMoney() {
      let param = new URLSearchParams()
      param.append('token', window.localStorage.getItem('token'))
      param.append('days', 'year')
      const { data: res } = await this.$http({
        method: 'post',
        url: 'api/mine/datainfo',
        data: param
      })
      for (let i = 0; i < res.data.length; i++) {
        this.option.xAxis.data.push(res.data[i].daytime)
        this.option.series[0].data.push(res.data[i].money)
        this.option.series[1].data.push(res.data[i].num)
      }
      this.SetEchart()
    },
    //报表
    SetEchart() {
      // 基于准备好的dom，初始化echarts实例
      let myChart = echarts.init(document.getElementById('main'))
      myChart.setOption(this.option)
    }
  },
  created() {
    if (!window.localStorage.getItem('token')) {
      this.$router.replace('/login')
      return
    }
    this.getYue()
    this.getMoney()
  }
}
</script>

<style lang="less" scoped>
.header {
  margin-bottom: 20px;
  .page-title {
    font-size: 24px;
  }
}
.cardtou {
  display: flex;
  justify-content: space-around;
  .one {
    width: 367px;
    height: 160px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.08);
    opacity: 1;
    border-radius: 10px;
    display: flex;
    align-items: center;
    img {
      width: 96px;
      height: 96px;
      margin-left: 20px;
    }
    .one-cont {
      display: flex;
      flex-direction: column;
      span {
        display: block;
        height: 32px;
        margin-left: 4px;
      }
      .one-yuan {
        font-size: 18px;
        color: rgba(89, 89, 89, 1);
      }
      .one-money {
        font-size: 32px;
        color: rgba(38, 38, 38, 1);
        margin-top: 10px;
      }
    }
  }
}
.dingdan {
  margin-left: 18px;
  margin-top: 33px;
  width: 1570px;
  height: 270px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.08);
  opacity: 1;
  border-radius: 10px;
  .ding-tou {
    width: 100%;
    height: 60px;
    display: flex;
    align-items: center;
    font-size: 20px;
    .ding-pic {
      width: 18px;
      height: 24px;
      margin: 0 6px 0 26px;
    }
  }
  .ding-cont {
    width: 100%;
    display: flex;
    .ding-left {
      width: 20%;
      margin-top: 21px;
      display: flex;
      flex-direction: column;
      align-items: center;
      button {
        width: 260px;
        height: 60px;
        background: rgba(24, 144, 255, 1);
        opacity: 1;
        border-radius: 10px;
        font-size: 24px;
        color: rgba(255, 255, 255, 1);
      }
      .ding-btn {
        background: rgb(166, 122, 89);
        margin-top: 20px;
      }
    }
    .ding-right {
      display: flex;
      margin-top: 16px;
      .two {
        width: 282px;
        height: 148px;
        border: 1px dashed #000;
        margin-right: 24px;
        cursor: pointer;
        span {
          display: block;
          font-size: 18px;
          margin-left: 30px;
          margin-top: 20px;
        }
        .two-num {
          color: rgba(24, 144, 255, 1);
          font-size: 30px;
        }
      }
      .two-1 {
        background: url(../../../assets/user/two1.png) no-repeat;
        background-size: auto 100%;
      }
      .two-2 {
        background: url(../../../assets/user/two2.png) no-repeat;
        background-size: auto 100%;
      }
      .two-3 {
        background: url(../../../assets/user/two3.png) no-repeat;
        background-size: auto 100%;
      }
      .two-4 {
        background: url(../../../assets/user/two4.png) no-repeat;
        background-size: auto 100%;
      }
    }
  }
}
.danhui {
  height: 380px;
  .huizong {
    width: 1420px;
    height: 273px;
    border: 1px dashed #000;
    margin: 0 58px 20px 58px;
  }
}
</style>